import sv from './sv.json';

export const messages = {
  sv,
};
